<script lang="ts" setup>
  import { NuxtLink } from '#components'
  import type { MenuItem } from '~/components/layout/SideBar.vue'
  import { HoverCard, HoverCardContent, HoverCardTrigger } from '~/components/ui/hover-card'

  const props = defineProps<{
    item: MenuItem
  }>()

  const tag = computed(() => (props.item.route ? NuxtLink : 'button'))

  const onClick = (): void => {
    props.item.action?.()
  }
</script>

<template>
  <HoverCard>
    <HoverCardTrigger>
      <component
        :is="tag"
        :to="item.route"
        :type="item.route ? undefined : 'button'"
        :aria-label="$t(item.label)"
        @click="onClick"
      >
        <div class="relative p-2 rounded-md overflow-hidden cursor-pointer text-white w-fit">
          <component :is="item.icon" class="size-5" />
        </div>
      </component>
    </HoverCardTrigger>
    <HoverCardContent align="start" side="right" :side-offset="1">
      <div class="bg-primary p-2 rounded-md">
        <div class="flex flex-col gap-2 text-white">{{ $t(item.label) }}</div>
      </div>
    </HoverCardContent>
  </HoverCard>
</template>
